import { authState } from "@shared/states/authState";
import { jwtCsrf } from "./csrf";

const UNSAFE_METHODS = ["POST", "PUT", "PATCH", "DELETE"];

function csrfToken(): string | undefined {
	const match = document.cookie.match(/(?:^|;\s*)csrf_access_token=([^;]+)/);
	return match ? decodeURIComponent(match[1]) : undefined;
}

// Auth is the shared HttpOnly cookie set by Planner. credentials:"include" sends
// it, and unsafe methods need the double-submit CSRF header.
export async function apiFetch(url: string, init: RequestInit = {}): Promise<Response> {
	const method = (init.method ?? "GET").toUpperCase();
	const headers = new Headers(init.headers);

	if (UNSAFE_METHODS.includes(method)) {
		const csrf = csrfToken() ?? jwtCsrf(authState.accessToken);
		if (csrf) headers.set("X-CSRF-TOKEN", csrf);
	}

	const response = await fetch(url, { ...init, headers, credentials: "include" });

	// Planner refreshes the short-lived token into the JSON body. Pick it up so
	// the RSO flow keeps a valid token without a re-login.
	response
		.clone()
		.json()
		.then((data) => {
			if (data?.access_token) {
				authState.accessToken = data.access_token;
			}
		})
		.catch(() => {});

	return response;
}
